/**
 * 英语
 */
export default {
  route: {
    dashboard: {
      _name: 'Console',
      workplace: {_name: 'Workplace'},
      analysis: {_name: 'Analysis'},
      monitor: {_name: 'Monitor'}
    },

    frontpage: {
      home: {_name: 'Home'},
      test: {_name: 'API Debug'},
    },

    system: {
      _name: 'Account Management',
      admin: {
        _name: 'Administrators',
        info: {_name: ''}
      },
      finance: {
        _name: 'Resource List',
        info: {_name: ''}
      },
      user: {
        _name: 'User Management',
        info: {_name: ''}
      },
      acceptor: {_name: 'Acceptor List'},
      menu: {_name: 'Menu'},
      tenantAdmin: {_name: 'Operator Accounts'},
      tenant: {_name: 'Operator List'},
      dictionary: {_name: 'Dictionary'},
      organization: {_name: 'Organization'},
      loginRecord: {_name: 'LoginRecord'},
      operRecord: {_name: 'OperRecord'}
    },

    resource: {
      _name: 'Resource Management',
      class: {_name: 'Resource Groups'},
      recolumn: {_name: 'Collection Resources'},
    },

    wallet: {
      _name: 'Wallet Settings',
      walletlist: {_name: 'Wallet List'},
      currency: {_name: 'Fiat Currency'},
      fiatcurrency: {_name: 'Fiat Currency'},
      virtualcurrency: {_name: 'Virtual Currency'},
      transmodel: {_name: 'Trading Models'},
    },

    config: {
      _name: 'System Setup',
      dictionary: {_name: 'Dictionaries'},
      website: {_name: 'Parameters'},
      role: {_name: 'Roles'},
      errorlog: {_name: 'System Maintenance'},
      countryregion: {_name: 'Country/Region'},
      banks: {_name: 'Bank Management'},
      clientSimulator: {_name: 'API Debug'},
      shuju: {_name: 'Data Cleanup'},
    },

    balance: {
      index: {_name: 'User Balance'},
    },

    channel: {
      _name: 'Channel Management',
      type: {_name: 'Channel Type'},
      uplist: {_name: 'Channel List'},
      dscolumn: {_name: 'Channel List (In)'},
      dfcolumn: {_name: 'Channel List (Out)'},
      amount: {_name: 'Preset Settings'},
      records: {_name: 'Preset Logs'},
      column: {_name: 'Sub-channel List'},
    },

    transaction: {
      _name: 'Transaction Management',
      inorder: {_name: 'Payment Order'},
      inlist: {_name: 'Payment Confirmation'},
      outorder: {_name: 'Transfer orders'},
      records: {_name: 'Balance Changes'},
      verifyorder: {_name: 'Verify Order'},
      errorlog: {_name: 'Merchant API Errors'},
      upstreamerrorlog: {_name: 'Upstream API Errors'},
    },

    reconciliation: {
      _name: 'Reconciliation Management',
      bussiness: {_name: 'User Bills'},
      uplist: {_name: 'Upstream Bills'},
      channel: {_name: 'Channel Bills'},
      shouyi: {_name: 'System Revenue'},
      bank: {_name: 'Resource Bills'},
      bankrecords: {_name: 'Collection Flow'},
      model: {_name: 'Peer-to-Peer Reconciliation'},
    },

    exception: {
      _name: 'Exception',
      '403': {_name: '403'},
      '404': {_name: '404'},
      '500': {_name: '500'}
    },
    user: {
      _name: 'Personal Settings',
      profile: {_name: 'Profile'},
      message: {_name: 'Message'}
    },
  },
  layout: {
    home: 'Home',
    header: {
      profile: 'Profile',
      password: 'Password',
      logout: 'SignOut'
    },
    footer: {
      website: 'Website',
      document: 'Document',
      authorization: 'Authorization',
      copyright: 'Copyright © 2021 NanJing RXThinkCMF R & D Center'
    },
    logout: {
      title: 'Confirm',
      message: 'Are you sure you want to log out?'
    }
  },
  login: {
    title: '海拉系统',
    username: 'please input username',
    password: 'please input password',
    captcha: 'please input code',
    remember: 'remember',
    forget: 'forget',
    login: 'login',
    loading: 'loading',
    ipChecking: 'Verifying access IP…',
    ipDenied: 'Your IP is not allowed to access',
    ipCheckFailed: 'IP verification failed. Please check your network or contact the administrator',
    googleAuthenticator: 'Google Authenticator (if bound)',
  },

  // 通用
  universal:{
    startingtime:"Starting Time",
    endtime:"EndTime",
    pleasechoose:"PleaseSelect",
    pleaseenter:"PleaseEnter",
    recognize: "Recognize",
    inquire:"Inquire",
    reset:"Reset",
    export:"Export",
    turnon:"Open",
    closure:"Close",
    yes:"yes",
    no:"no",
    unknown: 'unknown',
    success: 'success',
    retreat: 'retreat',
    abnormal: 'abnormal',
    cancel: 'cancel',
  },
  // 首页
  home:{
    totalbalance:"balance (accountancy)",
    availablebalance:"Available Balance",
    freezebalance:"Amount frozen",
    unsettledamount:"Unliquidated balances",
  },
  // 清理数据
  cleandata:{
    selecttime:"Select Time",
    startingtime:"Start Time",
    endtime:"End Time",
    selectdata:"Select Data",
    choose:"Please select",
    option1:"[ All Data ] | Choose carefully, you can't recover after deletion.",
    option2:"[ Collection Data ] | Choose carefully, it can't be recovered after deletion.",
    option3:"[ Disbursement Data ] | Choose carefully, you can't recover after deletion.",
    option4:"[ Account Change Data ] | Choose carefully, you can't recover after deletion.",
    warnings: "Tip: Please delete carefully, you can not recover after the operation.",
    recognize: "Confirm Cleanup",
    confirmTitle: "Confirm",
    confirmDelete: "Confirm Delete",
  },
  maintenance: {
    errorLog: 'Error Log',
    paymentLog: 'Debug Log',
    dataClean: 'Data Cleanup',
    logTime: 'Time',
    logFile: 'Log File',
    logContent: 'Content',
    clearLog: 'Clear Error Logs',
    clearPaymentLog: 'Clear Debug Logs',
    clearLogConfirm: 'Are you sure you want to clear all error logs? This cannot be undone.',
    clearPaymentLogConfirm: 'Are you sure you want to clear all debug logs? This cannot be undone.',
  },
   // 订单列表
   orderlist:{
    username:"Name",
    userorder:"User",
    systemorder:"System",
    transactiontype:"Type",
    channelorder:"Channel",
    tradingstatus:"Status",
    transactionaccountchanges:"Details",
    selectionperiod:"Time",
  },
  // 头部统计
  statistics:{
    today_success:"[Success today]:",
    today_receipt:"[Collect today]:",
    unknown_orders:" [Unknown order]:",
    unknown_amount:" [Unknown amount]:",
    service_fee:" [Handling fee]:",
    order_rate:" [Order rate]:",
  }
}
